import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import { DifficultyBadge, DebugQuizId } from "./debug-quiz-id.js";
import { useQuizStyleVariant, useQuizHeaderSuffix } from "./quiz-style-context.js";
const CHIP_BG = {
  adult: "bg-blue-500",
  student: "bg-lc-lightblue-900"
};
function QuizTypeBadge({ quizId, typeLabel, difficultyLevel, variant = "adult" }) {
  const styleVariant = useQuizStyleVariant();
  const headerSuffix = useQuizHeaderSuffix();
  const isLcStudent = styleVariant === "lc" && variant === "student";
  const isAiqStudent = styleVariant === "aiq" && variant === "student";
  return /* @__PURE__ */ jsxs("div", { "data-quiz-type-badge": true, className: "inline-flex gap-2 items-center", children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          isLcStudent ? "inline-flex items-center text-[16px] font-semibold leading-[1.6] text-lc-text-link" : isAiqStudent ? "inline-flex h-[26px] items-center rounded-md bg-lc-key-500 px-2 text-[14px] font-semibold leading-none tracking-[0.2px] text-white" : "inline-flex items-center gap-2 rounded-lg px-3 py-1 text-sm font-bold text-white",
          !isLcStudent && !isAiqStudent && CHIP_BG[variant]
        ),
        children: /* @__PURE__ */ jsx("span", { children: typeLabel })
      }
    ),
    isLcStudent ? headerSuffix : null,
    isAiqStudent && difficultyLevel != null ? /* @__PURE__ */ jsxs("span", { className: "inline-flex h-5 items-center rounded-full bg-lc-key-50 px-2 text-[12px] font-semibold leading-none tracking-[0.3px] text-lc-key-500", children: [
      "Lv.",
      difficultyLevel
    ] }) : null,
    !isLcStudent && !isAiqStudent ? /* @__PURE__ */ jsx(DifficultyBadge, { level: difficultyLevel }) : null,
    !isLcStudent && /* @__PURE__ */ jsx(DebugQuizId, { quizId })
  ] });
}
export {
  QuizTypeBadge
};
//# sourceMappingURL=quiz-type-badge.js.map
